{
  "version": "2026-09-29",
  "githubRepository": "satoki252595/paperstock",
  "workerOrigin": "https://paperstock.satoki252595.workers.dev",
  "maxBodyBytes": 8192,
  "maxIdentifierChars": 1000,
  "maxQuestionChars": 1000,
  "clientWindowSeconds": 3600,
  "maxRequestsPerClient": 3,
  "globalWindowSeconds": 86400,
  "maxRequestsPerWindow": 50,
  "batchSize": 10,
  "timeoutMs": 15000,
  "issueTitleChars": 120,
  "memoryBucket": {
    "capacity": 5,
    "refillPerSecond": 0.05
  },
  "issuePageSize": 100,
  "maxIssuePages": 20
}
